'use client'

import { Box, Flex, Text } from '@mantine/core'

import NextBaseImage from '@/components/basic/BaseImage'
import PriceChange from '@/components/PriceChange'
import useTradableCoins from '@/hooks/business/useTradableCoins'
import { I18nLink } from '@/i18n/navigation'
import { CoinCategory } from '@/services/category'

import CategoryCoin from './CategoryCoin'
import styles from './styles.module.css'

type CategoryCardProps = {
  data: CoinCategory
}

export default function CategoryCard({ data }: CategoryCardProps) {
  const priceChange24h = Number(data.percent_change_24h_native) * 0.01 || 0

  const displayCoins = useTradableCoins({
    coins: data.highlighted_coins,
    maxCount: 2,
  })

  return (
    <I18nLink href={`/categories/${data.slug}`}>
      <Box className={styles.cardContainer}>
        {/* Image Container */}
        <Box className={styles.imageWrapper}>
          <NextBaseImage
            src={data.image_url}
            width="100%"
            height="100%"
            alt={data.name}
            fallbackBg="var(--bg-surface-secondary)"
            className={styles.backgroundImage}
          />
          <Box className={styles.imageOverlay} />
        </Box>
        <Flex className={styles.imageContainer}>
          <Text variant="heading2" truncate className={styles.textContainer}>
            {data.name}
          </Text>
          <PriceChange value={priceChange24h} pl={16} variant="body-emphasis" />
        </Flex>

        {/* Content */}
        {displayCoins.length > 0 && (
          <Flex className={styles.contentContainer} gap={12}>
            {displayCoins.map(coin => (
              <CategoryCoin key={coin.id} coin={coin} />
            ))}
          </Flex>
        )}
      </Box>
    </I18nLink>
  )
}
